import { useLocation } from "react-router-dom";
import DialogBox from "../../components/UI/DialogBox";
import { handleErrMessage } from "../../functions/handleErrMessage";
import { Add_EXPENSE } from "../../api/allApi_List";
import usePostData from "../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../layout/MainPageLayout";
import { prepareFormData } from "../../functions/prepareFormData";
import SalaryAdjustmentForm from "../../components/expense/add/SalaryAdjustmentForm";

const SalaryModificationPage = () => {
  const { executePost, loading, formError, setFormError, successResponse } =
    usePostData();

  const location = useLocation();

  const isBonusPage = location.pathname.includes("add-overtime");
  const isDeductionPage = location.pathname.includes("salary-deduction");

  const pageInfo = isBonusPage
    ? { name: "Add Overtime Amount", category: 1 }
    : isDeductionPage
      ? { name: "Salary Deduction", category: 2 }
      : { name: "", category: null }; // fallback

  // execute post api
  const sendData = async (data, reset) => {
    // send data into form data
    const formData = prepareFormData(data);
    //API calling
    executePost(formData, Add_EXPENSE, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: pageInfo.name }}>
      <SalaryAdjustmentForm
        sendData={sendData}
        loading={loading}
        pageInfo={pageInfo}
        successResponse={successResponse}
      />
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default SalaryModificationPage;
